export default __webpack_public_path__ + "static/media/Southwestern-Cheeseburger-Sliders.c2387695.jpg";